module.exports = __webpack_public_path__ + "static/media/woman-phone.c813f65c.jpg";